import { useSessionItems } from "lib/redux/sessions/lists/session-items-hook";
import { SessionHistoryTabs, SessionDetailView } from "components/History/views";
import { FilterOperator } from "interfaces/sessions";
import { BackendTables } from "interfaces/db";
import { SessionV2Columns } from "interfaces/table";

export function useSessionByNumbers(numbers: string[], view: SessionDetailView = SessionDetailView.EMBEDDED) {
    // Use session-items-hook with phone number filter
    const sessionData = useSessionItems({
        passed_filter: numbers.length > 0 ? [[{
            column_name: SessionV2Columns.CUSTOMER_ADDRESS,
            operator: FilterOperator.IN,
            value_safe: numbers,
            table: BackendTables.SESSIONS_V2,
        }]] : null,
        enforced_start: null,
        enforced_end: null,
        tab: SessionHistoryTabs.ALL_HISTORY,
        view,
        disableDebouncing: true
    });

    return {
        items: sessionData.items,
        count: sessionData.count,
        isLoading: sessionData.isLoading,
        hasData: sessionData.hasData,
        error: sessionData.error
    };
} 